<div class="modal-backdrop" *ngIf="open" (click)="onBackdropClick()"></div>

<section class="modal" *ngIf="open" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">
  <div class="modal-icon" [class.warning]="variant === 'warning'" [class.danger]="variant === 'danger'">
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path
        d="M12 3 1.7 21h20.6L12 3z"
        fill="currentColor"
        opacity=".12"
      />
      <path
        d="M12 8v5"
        fill="none"
        stroke="currentColor"
        stroke-width="2.2"
        stroke-linecap="round"
      />
      <circle cx="12" cy="16.8" r="1.2" fill="currentColor" />
    </svg>
  </div>

  <h2 class="modal-title">{{ title }}</h2>

  <p class="modal-message" *ngIf="message">{{ message }}</p>
  <p class="modal-highlight" *ngIf="highlight">{{ highlight }}</p>

  <div class="modal-body">
    <ng-content></ng-content>
  </div>

  <footer class="modal-footer">
    <button *ngIf="secondaryText" type="button" class="modal-btn secondary" (click)="secondary.emit()">
      {{ secondaryText }}
    </button>
    <button type="button" class="modal-btn primary" (click)="primary.emit()" [disabled]="primaryDisabled">
      {{ primaryText }}
    </button>
  </footer>
</section>
